var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled from 'styled-components';
import { View, INDENT } from "../View";
import { createUIElement, SPACING_M } from "../helpers";
var Root = styled(View)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    position: relative;\n    overflow-y: auto;\n    overflow-x: hidden;\n    padding-top: ", ";\n    flex-direction: column;\n    align-items: stretch;\n\n    > * {\n        max-width: 100%;\n    }\n"], ["\n    position: relative;\n    overflow-y: auto;\n    overflow-x: hidden;\n    padding-top: ", ";\n    flex-direction: column;\n    align-items: stretch;\n\n    > * {\n        max-width: 100%;\n    }\n"])), function (_a) {
    var hasTopPadding = _a.hasTopPadding;
    return (hasTopPadding ? SPACING_M : '0');
});
export var DialogWizardStepContent = createUIElement('DialogWizardStepContent', function (_a, ref) {
    var _b;
    var className = _a.className, render = _a.render, children = _a.children, _c = _a.hasTopPadding, hasTopPadding = _c === void 0 ? true : _c, onClick = _a.onClick, onMouseDown = _a.onMouseDown, onMouseUp = _a.onMouseUp, onMouseEnter = _a.onMouseEnter, onMouseLeave = _a.onMouseLeave, onKeyDown = _a.onKeyDown, onKeyUp = _a.onKeyUp, onKeyPress = _a.onKeyPress, style = _a.style, rest = __rest(_a, ["className", "render", "children", "hasTopPadding", "onClick", "onMouseDown", "onMouseUp", "onMouseEnter", "onMouseLeave", "onKeyDown", "onKeyUp", "onKeyPress", "style"]);
    return (React.createElement(Root, __assign({}, rest, { "data-selector-id": rest['data-selector-id'] || 'dialog-wizard-step-content', className: "vm-DialogWizardStepContent " + className, hasTopPadding: hasTopPadding, spaceHorizontal: INDENT.m, spaceBottom: INDENT.m, onClick: onClick, onMouseDown: onMouseDown, onMouseUp: onMouseUp, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onKeyPress: onKeyPress, ref: ref, style: style }), (_b = render === null || render === void 0 ? void 0 : render()) !== null && _b !== void 0 ? _b : children));
});
var templateObject_1;
//# sourceMappingURL=DialogWizardStepContent.js.map